/*
https://github.com/themesberg/flowbite-icons
Flowbite Icons is free and open-source under the MIT License.
*/
import React from 'react';

interface Props {
    readonly className?: string;
}

export default function LinkedIn({
    className = null,
}: Props) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10.5323 6.01416C10.1014 5.996 9.67273 6.08309 9.28851 6.26688C8.90429 6.45067 8.57768 6.72485 8.3407 7.06252V6.00616H6.2287V12.6666H8.35564V9.4563C8.35564 8.60908 8.56328 7.79117 9.78141 7.79117C11.0372 7.79117 11.2001 8.75961 11.2001 9.51224V12.6666H13.3334V9.10662C13.3334 7.35824 12.8356 6.01416 10.5323 6.01416Z" fill="currentColor" />
            <path d="M3.73342 3.33331C3.52245 3.33331 3.31622 3.39191 3.14081 3.50169C2.96539 3.61147 2.82868 3.7675 2.74794 3.95006C2.66721 4.13261 2.64609 4.33349 2.68724 4.52729C2.7284 4.7211 2.82999 4.89911 2.97917 5.03884C3.12834 5.17856 3.31841 5.27371 3.52532 5.31226C3.73223 5.35081 3.9467 5.33103 4.14161 5.25541C4.33652 5.17979 4.50311 5.05174 4.62032 4.88744C4.73752 4.72314 4.80008 4.52998 4.80008 4.33239C4.80008 4.06741 4.6877 3.8133 4.48766 3.62593C4.28762 3.43857 4.01631 3.33331 3.73342 3.33331Z" fill="currentColor" />
            <path d="M4.80008 6.01416H2.66675V12.6666H4.80008V6.01416Z" fill="currentColor" />
        </svg>
    );
}
